<div class="container">
  <h2 mat-dialog-title>{{ data.header }}</h2>
  <mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>
  <div mat-dialog-actions class="btn-container">
    <button
      type="button"
      mat-stroked-button
      color="primary"
      (click)="onCancelClick()"
    >
      {{ data.cancelText || translationService.getCancelText() }}
    </button>
    <button
      type="button"
      mat-raised-button
      color="accent"
      (click)="onConfirmClick()"
    >
      {{ data.confirmText || translationService.getConfirmText() }}
    </button>
  </div>
</div>
